// Status

export const DEPOSIT_STATUS = {
  PENDING: {
    key: "PENDING",
    className: "btn btn-warning p-1",
  },
  SUCCESS: {
    key: "SUCCESS",
    className: "btn btn-success p-1",
  },
  CANCELED: {
    key: "CANCELED",
    className: "btn btn-danger p-1",
  },
};
export const geDepositsStatuses = () => {
  return Object.values(DEPOSIT_STATUS);
};
export const geDepositStatusClassName = (status) => {
  return DEPOSIT_STATUS[status.toUpperCase()].className;
};
